import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Label, Button, Alert } from "reactstrap"

import DPTextBox from "framework/components/DPTextBox"
import DBFileBrowser from "framework/components/DBFileBrowser"
import DPSwitch from 'framework/components/DPSwitch'
import DPDropDown from "framework/components/DPDropDown"
import DPImage from "framework/components/DPImage"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/Customer.xlsx";
import DPImagePop from 'framework/components/DPImagePop'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"

const CustomerMasterTab1 = ({
  fieldManager,
  SwonChange,
  ActiveSw,
  disabled,
  disablecode,
  CusCodeVlaue,
  CusCodeOnChange,
  CusCodeOnBlur,
  CusFNameValue,
  CusFNAmeOnChange,
  CusLNameValue,
  CusLNameOnChange,
  CusFuNameValue,
  CusFuNameOnChange,
  CusGroupVlaue,
  CusGroupOnChange,
  CusRefValue,
  CusRefOnChange,
  CusNICValue,
  CusNICOnChange,
  CusRCodeValue,
  CusRCodeOnChange,
  CusLocationValue,
  CusLocationOnChange,
  ShowPreview,
  modelTrigger,
  modelOpen,
  GetSelectRow,
  imagesrc,
  show,
  AlertMsg,
  AlertColor,
  TitleValue,
  TitleOnChange,
  nicOnBlur,
  fileValue,
  fileOnChange,
  nameOnblur,
  LnameOnBlur,
  FnameOnBlur,
  filevalue,
  menuName,
  onButtonClick,
  btnDisable,
  showFileUpload,
  valueUpload,
  menuCode,
  RemoveImage,
  DisableSearch,
  autoCode,
}) => {

  const [customerGroup, SetCustomerGroup] = useState([])
  const [titleGroup, SetTitleGroup] = useState([])
  const [location, SetLocation] = useState([])
  //*** End of useStates */


  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")

  useEffect(async () => {
    setHeadColumns(await loadPopupSearchPay(menuCode, 'CUSTOMER'))
  }, [menuCode]);



  const [isOpen, SetIsOpen] = useState(false)
  const showPop = () => {
    SetIsOpen(!isOpen)
  }

  const ApiURL = window.Links.ApiURL
  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /**************get customerGroup data */
    function getCustomerGroup() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}customergroup/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetCustomerGroup(result.data)
          let dt = result.data

        }).catch(error => console.log('error', error));
    }
    /**************get customerGroup data  End*/

    /**************get location data */
    function getLocation() {
      var requestOptions = {
        method: 'GET',
        headers: {

          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Locations/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetLocation(result.data)
        }).catch(error => console.log('error', error));
    }
    /**************get location data End*/

    /**************get Title data */
    function getTitle() {
      var requestOptions = {
        method: 'GET',
        headers: {

          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Title/Select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetTitleGroup(result.data)
          let dt = result.options
        }).catch(error => console.log('error', error));
    }
    /**************get Title data End*/
    getCustomerGroup()
    getLocation()
    getTitle()
  }, []);


  async function tog_backdrop() {
    let dt;
    // const ApiURL = window.Links.ApiURL
    // await fetch(`${ApiURL}Customer`, {
    //   method: "GET",
    //   headers: { "Content-Type": "application/json" },
    // })
    //   .then(Response => Response.json())
    //   .then(responseData => {
    //     SetDatatable(responseData.data)
    //     dt = responseData.data
    //   })
    // let i = 1;
    // dt.map((r) => {
    //   searchData = searchData.concat(TableDataBuilder(i, r))
    //   i++
    // });
    // SetDatatable(searchData);
    modelTrigger();
  }

  // const columns = [{
  //   dataField: 'id',
  //   text: 'Id',
  // }, {
  //   dataField: 'code',
  //   text: 'Code',
  // }, {
  //   dataField: 'name',
  //   text: 'Full Name',
  // }, {
  //   dataField: 'active',
  //   text: 'Active',
  // }];

  const columns = [{
    field: 'code',
    title: 'Code',
    align: "center"
  }, {
    field: 'name',
    title: 'Full Name',
    align: "center"
  }, {
    field: 'status',
    title: 'Status',
    align: "center"
  }];

  //default sorted method
  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  //Table data
  var searchData = [];
  const TableDataBuilder = (id, Data) => {
    return { "id": id, "code": Data.strCode, "name": Data.strFullName, "active": Data.intStatus == '1' ? 'Active' : 'Inactive' }
  }


  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                  </Alert>
                ) : null}
                <Col sm={12} md={6} className="mb-4-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_CODE')}>
                    <DPTextBoxButton
                      rowClass="mb-4-sm"
                      labelText="Customer Code *"
                      textType="text"
                      maxLength="10"
                      value={CusCodeVlaue}
                      onChange={CusCodeOnChange}
                      onBlur={CusCodeOnBlur}
                      disabled={disabled == true ? disabled : disablecode || fieldManager.disable.includes('CM_CODE')}
                      onButtonClick={onButtonClick}
                      btnDisable={disabled == true ? disabled : btnDisable || fieldManager.disable.includes('CM_CODE')}
                      placeholder={autoCode}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_TITLE')}>
                    <DPDropDown
                      labelText="Customer Title *"
                      rowClass="mb-4-sm"
                      optionGroup={titleGroup}
                      selectedGroup={TitleValue}
                      onChange={TitleOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_TITLE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_FNAME')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="First Name *"
                      textType="text"
                      maxLength="40"
                      value={CusFNameValue}
                      onChange={CusFNAmeOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_FNAME')}
                      onBlur={FnameOnBlur}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LNAME')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Last Name"
                      textType="text"
                      maxLength="40"
                      value={CusLNameValue}
                      onChange={CusLNameOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_LNAME')}
                      onBlur={LnameOnBlur}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_FULLNAME')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Full Name"
                      textType="text"
                      maxLength="40"
                      value={CusFuNameValue}
                      onChange={CusFuNameOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_FULLNAME')}
                      onBlur={nameOnblur}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_GROUP')}>
                    <DPDropDown
                      labelText="Customer Group *"
                      rowClass="mb-4-sm"
                      optionGroup={customerGroup}
                      selectedGroup={CusGroupVlaue}
                      onChange={CusGroupOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_GROUP')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LINKREF')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Reference Code"
                      textType="text"
                      maxLength="5"
                      value={CusRefValue}
                      onChange={CusRefOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_LINKREF')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_NIC')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="NIC Number"
                      textType="text"
                      maxLength="12"
                      value={CusNICValue}
                      onChange={CusNICOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_NIC')}
                      onBlur={nicOnBlur}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_GLCODE')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Reference Code To GL"
                      textType="text"
                      maxLength="5"
                      value={CusRCodeValue}
                      onChange={CusRCodeOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_GLCODE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_STATUS')}>
                    <Row>
                      <Col sm={3}>Active</Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={SwonChange}
                          checked={ActiveSw}
                          disabled={disabled || fieldManager.disable.includes('CM_STATUS')}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LOC')}>
                    <DPDropDown
                      labelText="Location *"
                      rowClass="mb-4-sm mt-2"
                      optionGroup={location}
                      selectedGroup={CusLocationValue}
                      onChange={CusLocationOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_LOC')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_FOLDERID')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="File/Folder ID"
                      textType="text"
                      maxLength="5"
                      value={fileValue}
                      onChange={fileOnChange}
                      disabled={disabled || fieldManager.disable.includes('CM_FOLDERID')}
                    />
                  </div>
                </Col>

                <Col sm={12} md={1} className="mb-4-sm">
                  <Button
                    onClick={() => {
                      tog_backdrop()
                    }}
                    color="success"
                    className="btn-sm"
                    disabled={DisableSearch}
                  >
                    <i
                      className="mdi mdi-search-web"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </Col>

                <Col sm={12} md={4} className="mb-4-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PHOTO')}>
                    <Row className="mb-4-sm">
                      <Label
                        htmlFor="example-text-input"
                        className="col-md-3 col-form-label-sm" >
                        Image Upload
                      </Label>
                      <div className="col-md-9">
                        <div>
                          <Row>
                            <Col sm="12">
                              <CardText className="mb-0">
                                <Row>
                                  <Col sm={12} md={12} className="mb-4-sm">
                                    <DPImage
                                      labelText={imagesrc}
                                      onClick={showPop}
                                      style={{ cursor: 'pointer' }}
                                    ></DPImage>
                                    <DPImagePop
                                      toggle={showPop}
                                      isOpen={isOpen}
                                      width={'400px'}
                                      height={'400px'}
                                      ImgSrc={imagesrc}
                                    />
                                    <DBFileBrowser
                                      accept="image/*"
                                      rowClass="mb-4-sm"
                                      showPrewiew={ShowPreview}
                                      disable={disabled || fieldManager.disable.includes('CM_PHOTO')}
                                      value={filevalue}
                                    ></DBFileBrowser>
                                  </Col>
                                </Row>
                              </CardText>
                            </Col>
                          </Row>
                        </div>
                        <div>
                        <Button
                          color="danger"
                          className="mr-1 mt-1 "
                          disabled={disabled}
                          onClick={RemoveImage}
                          size="sm"
                        >
                          Remove Image
                        </Button>
                      </div>
                      </div>
                    </Row>
                  </div>
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={disablecode || fieldManager.disable.includes('')}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />
                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disablecode == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                        style={{ pointerEvents: disablecode ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disablecode == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>
                </Col>
                {/* <DPSearchBoxTesting
                  searchData={DataTables}
                  columns={columns}
                  defaultSorted={defaultSorted}
                  mainTitle={menuName + " Search"}
                  SelectType={'radio'}//checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"Customer"}
                /> */}


                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={HeadColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={menuName + " Search"}
                  SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"CUSTOMER"}
                  MenuCode={menuCode}
                  KeyVal={"CUS"}
                  searchBy={"CM_CODE"}
                  FilterStr={groupFilter}
                />


              </Row>
            </CardText>
          </Col>
        </Row >
      </div >
    </React.Fragment >
  )
}
export default CustomerMasterTab1
